<template>
  <a-menu-item :key="menuInfo.key" v-bind="$props">
    <router-link v-if="menuInfo.url" :to="menuInfo.url">
      <span :class="styles.title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <component
        v-if="isIconComponent"
        :is="menuInfo.icon"
        :class="styles.icon"
        :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
      />
      <img
        v-else-if="isIconImage"
        :src="menuInfo.icon"
        :class="styles.icon"
        :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
      />
      <i
        v-else
        :class="[styles.icon, menuInfo.icon]"
        :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
      />
    </router-link>
    <span v-if="!menuInfo.url" :to="menuInfo.url">
      <span :class="styles.title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <template v-if="menuInfo.icon">
        <component
          v-if="isIconComponent"
          :is="menuInfo.icon"
          :class="styles.icon"
          :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
        />
        <img
          v-else-if="isIconImage"
          :src="menuInfo.icon"
          :class="styles.icon"
          :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
        />
        <i
          v-else
          :class="[styles.icon, menuInfo.icon]"
          :style="{ 'padding-left': settings.isMenuCollapsed ? '0.3em' : null }"
        />
      </template>
    </span>
  </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'SubMenu',
  props: {
    ...Menu.Item.props,
    menuInfo: {
      type: Object,
      default: () => {},
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const store = useStore()
    const settings = computed(() => store.getters.settings)

    const isIconImage = computed(() => {
      const icon = props.menuInfo.icon
      return (
        typeof icon === 'string' &&
        (icon.includes('/') || icon.includes('http') || icon.startsWith('data:'))
      )
    })

    const isIconComponent = computed(() => {
      const icon = props.menuInfo.icon
      return icon && (typeof icon === 'object' || typeof icon === 'function')
    })

    return {
      settings,
      isIconImage,
      isIconComponent,
    }
  },
}
</script>
